import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalProps,
  VStack,
} from '@tq/ui-components';

import { MobileModal } from 'components';
import { SideFilter } from '../SideFilter';

export type FilterModalProps = Pick<ModalProps, 'onClose' | 'isOpen'>;
export const FilterModal: React.FC<FilterModalProps> = ({ ...modalProps }) => {
  const { t } = useTranslation('filter_modal');
  return (
    <Box data-testid='filter-modal'>
      <MobileModal {...modalProps}>
        <ModalHeader
          aria-label={t('filter_consultations_modal', 'Filter consultations modal')}
        >
          {t('filter_consultations', 'Filter consultations')}
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <SideFilter />
        </ModalBody>
        <ModalFooter>
          <VStack width='100%'>
            <Button isFullWidth>{t('apply_filters', 'Apply filters')}</Button>
            <Button isFullWidth variant='tertiary' onClick={modalProps.onClose}>
              {t('cancel', 'Cancel')}
            </Button>
          </VStack>
        </ModalFooter>
      </MobileModal>
    </Box>
  );
};
